/* Dobby & Co: conversion features (deal countdown, first visit offer, free shipping bar, delivery estimate, duo upsell, welcome popup) */
(function () {
  var P = window.DobbyPromo || {};
  var end = P.dealEnd ? Date.parse(P.dealEnd) : NaN;
  var lang = document.documentElement.lang || 'en';

  function live() { return !!P.dealOn; }

  /* ---------- first visit offer: real per-visitor window ---------- */
  var FV_KEY = 'dc_fv_start';
  var fvEnd = NaN;
  if (P.fvOn && P.fvCode && P.fvHours) {
    var fvStart = NaN;
    try {
      fvStart = parseInt(localStorage.getItem(FV_KEY), 10);
      if (!fvStart) { fvStart = Date.now(); localStorage.setItem(FV_KEY, String(fvStart)); }
    } catch (e) { fvStart = NaN; }
    fvEnd = fvStart + P.fvHours * 3600e3;
  }
  function fvLive() { return !isNaN(fvEnd) && fvEnd > Date.now(); }
  function cutoffLive() { return !isNaN(end) && end > Date.now(); }
  function pad(n) { return String(n).padStart(2, '0'); }
  function parts(ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    return { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
  }
  function cur() { return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CAD'; }
  function rate() { var r = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate); return r > 0 ? r : 1; }
  function money(cents) {
    try { return new Intl.NumberFormat(lang, { style: 'currency', currency: cur(), maximumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  /* ---------- countdowns ---------- */
  function drawTimer(el, target) {
    var t = parts((target || end) - Date.now());
    if (el.dataset.style === 'boxes') {
      var units = [['d', 'Days'], ['h', 'Hours'], ['m', 'Min'], ['s', 'Sec']];
      if (!el.firstChild) {
        el.innerHTML = units.map(function (u) { return '<span class="dc-tbox"><b data-u="' + u[0] + '"></b><small>' + u[1] + '</small></span>'; }).join('');
      }
      units.forEach(function (u) { var b = el.querySelector('[data-u="' + u[0] + '"]'); if (b) b.textContent = pad(t[u[0]]); });
    } else {
      el.textContent = (t.d ? t.d + 'd ' : '') + pad(t.h) + 'h ' + pad(t.m) + 'm ' + pad(t.s) + 's';
    }
  }
  var VIS = '[data-dc-deal],[data-dc-nodeal],[data-dc-cutoff],[data-dc-fv],[data-dc-nofv]';
  function visible(el, st) {
    if (el.hasAttribute('data-dc-deal') && !st.deal) return false;
    if (el.hasAttribute('data-dc-nodeal') && st.deal) return false;
    if (el.hasAttribute('data-dc-cutoff') && !st.cut) return false;
    if (el.hasAttribute('data-dc-fv') && !st.fv) return false;
    if (el.hasAttribute('data-dc-nofv') && st.fv) return false;
    return true;
  }
  var lastState = '';
  function syncDeal() {
    var st = { deal: live(), cut: cutoffLive(), fv: fvLive() };
    var key = st.deal + '|' + st.cut + '|' + st.fv;
    if (key !== lastState) {
      document.querySelectorAll(VIS).forEach(function (el) { el.hidden = !visible(el, st); });
      if (lastState && !st.fv) fvRemove();
      lastState = key;
    }
    if (st.cut) document.querySelectorAll('[data-dc-timer]').forEach(function (el) { drawTimer(el); });
    if (st.fv) document.querySelectorAll('[data-dc-fv-timer]').forEach(function (el) { drawTimer(el, fvEnd); });
  }

  /* ---------- first visit offer: cart code ---------- */
  function cartCodes(cart) {
    return (cart.discount_codes || []).map(function (d) { return d.code; });
  }
  function setCodes(codes) {
    return fetch(root() + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    });
  }
  function fvApply() {
    if (!fvLive()) return;
    try { if (sessionStorage.getItem('dc_fv_applied')) return; } catch (e) {}
    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var codes = cartCodes(cart);
        if (codes.some(function (c) { return c.toUpperCase() === P.fvCode.toUpperCase(); })) return;
        if (codes.length) return; /* shopper entered their own code: leave it alone */
        return setCodes([P.fvCode]);
      })
      .then(function () { try { sessionStorage.setItem('dc_fv_applied', '1'); } catch (e) {} })
      .catch(function () {});
  }
  function fvRemove() {
    if (!P.fvCode) return;
    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var codes = cartCodes(cart);
        var keep = codes.filter(function (c) { return c.toUpperCase() !== P.fvCode.toUpperCase(); });
        if (keep.length !== codes.length) return setCodes(keep).then(function () { location.reload(); });
      })
      .catch(function () {});
  }
  function fvPrices() {
    var pct = P.fvPct || 0;
    document.querySelectorAll('[data-dc-fv-price]:not([data-dc-i])').forEach(function (el) {
      el.setAttribute('data-dc-i', '');
      var c = parseInt(el.dataset.cents, 10);
      if (c) el.textContent = money(Math.round(c * (100 - pct) / 100));
    });
    document.querySelectorAll('[data-dc-fv-pct]:not([data-dc-i])').forEach(function (el) { el.setAttribute('data-dc-i', ''); el.textContent = pct; });
  }

  /* ---------- free shipping progress ---------- */
  function drawShip(el) {
    if (!P.shipOn || !P.shipThreshold) return;
    var goal = Math.round(P.shipThreshold * rate());
    var total = parseInt(el.dataset.total, 10) || 0;
    var left = goal - total;
    var msg = el.querySelector('[data-dc-ship-msg]');
    var fill = el.querySelector('[data-dc-ship-fill]');
    if (left <= 0) { msg.innerHTML = '<strong>You unlocked free shipping!</strong>'; el.classList.add('is-done'); }
    else { msg.innerHTML = 'You are <strong>' + money(left) + '</strong> away from free shipping'; }
    fill.style.width = Math.min(100, Math.round((total / goal) * 100)) + '%';
    el.hidden = false;
  }

  /* ---------- delivery estimate ---------- */
  function drawEta(el) {
    var span = el.querySelector('[data-dc-eta-range]');
    if (!span) return;
    var f = { month: 'short', day: 'numeric' };
    var a = new Date(Date.now() + (P.etaMin || 7) * 864e5).toLocaleDateString(lang, f);
    var b = new Date(Date.now() + (P.etaMax || 16) * 864e5).toLocaleDateString(lang, f);
    span.textContent = a + ' – ' + b;
  }

  /* ---------- one-time setup per element (also for re-rendered cart drawer) ---------- */
  function scan() {
    var st = { deal: live(), cut: cutoffLive(), fv: fvLive() };
    Array.prototype.forEach.call(document.querySelectorAll(VIS), function (el) {
      if (el.hasAttribute('data-dc-v')) return;
      el.setAttribute('data-dc-v', '');
      el.hidden = !visible(el, st);
    });
    document.querySelectorAll('[data-dc-pct]:not([data-dc-i])').forEach(function (el) { el.setAttribute('data-dc-i', ''); if (P.pct) el.textContent = P.pct; });
    document.querySelectorAll('[data-dc-ship]:not([data-dc-i])').forEach(function (el) { el.setAttribute('data-dc-i', ''); drawShip(el); });
    document.querySelectorAll('[data-dc-eta]:not([data-dc-i])').forEach(function (el) { el.setAttribute('data-dc-i', ''); drawEta(el); });
    fvPrices();
    if (st.cut) document.querySelectorAll('[data-dc-timer]').forEach(function (el) { drawTimer(el); });
    if (st.fv) document.querySelectorAll('[data-dc-fv-timer]').forEach(function (el) { drawTimer(el, fvEnd); });
  }

  /* ---------- duo upsell: add one or both items ---------- */
  function mainVariantId() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var f = forms[i];
      if (f.closest('[data-dc-pair]') || f.classList.contains('dc-costume__form')) continue;
      var input = f.querySelector('[name="id"]');
      if (input && input.value) return input.value;
    }
    return null;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-dc-pair-add]');
    if (!btn) return;
    var box = btn.closest('[data-dc-pair]');
    var other = box && box.querySelector('[data-dc-pair-variant]');
    if (!other || !other.value) return;
    var items = [{ id: Number(other.value), quantity: 1 }];
    if (!btn.hasAttribute('data-only-other')) {
      var main = mainVariantId();
      if (main) items.unshift({ id: Number(main), quantity: 1 });
    }
    var label = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding…';
    fetch(root() + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      try { sessionStorage.removeItem('dc_fv_applied'); } catch (e) {}
      window.location.href = root() + 'cart';
    }).catch(function () {
      btn.disabled = false; btn.textContent = label;
      alertless(box, 'Sorry, that size could not be added. Please try another one.');
    });
  });
  function alertless(box, text) {
    var p = box.querySelector('.dc-pair__err');
    if (!p) { p = document.createElement('p'); p.className = 'dc-pair__err'; box.appendChild(p); }
    p.textContent = text;
  }

  /* ---------- welcome popup ---------- */
  function popup() {
    var el = document.querySelector('[data-dc-popup]');
    if (!el) return;
    var KEY = 'dc_popup_seen';
    function close() {
      el.classList.remove('is-open');
      setTimeout(function () { el.hidden = true; }, 250);
    }
    function open() {
      if (!el.hidden) return;
      el.hidden = false;
      requestAnimationFrame(function () { el.classList.add('is-open'); });
      try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
      var input = el.querySelector('input[type="email"]');
      if (input) setTimeout(function () { input.focus({ preventScroll: true }); }, 300);
    }
    el.addEventListener('click', function (e) { if (e.target.closest('[data-dc-popup-close]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !el.hidden) close(); });
    var copy = el.querySelector('[data-dc-copy]');
    if (copy) copy.addEventListener('click', function () {
      var lbl = copy.querySelector('[data-dc-copy-label]');
      try { navigator.clipboard.writeText(copy.dataset.dcCopy); lbl.textContent = 'Copied!'; } catch (e) {}
    });
    if (el.classList.contains('is-done')) {
      try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
      return;
    }
    if (!P.popupOn || fvLive()) return; /* during the first visit offer the 10% popup would be a worse deal */
    var seen = 0;
    try { seen = parseInt(localStorage.getItem(KEY), 10) || 0; } catch (e) { return; }
    if (Date.now() - seen < 14 * 864e5) return;
    var timer = setTimeout(open, (P.popupDelay || 12) * 1000);
    if (window.matchMedia('(pointer: fine)').matches) {
      document.addEventListener('mouseout', function onOut(e) {
        if (!e.relatedTarget && e.clientY <= 0) { clearTimeout(timer); open(); document.removeEventListener('mouseout', onOut); }
      });
    }
  }

  function start() {
    scan();
    syncDeal();
    if (fvLive()) fvApply();
    else if (!isNaN(fvEnd)) fvRemove();
    popup();
    setInterval(syncDeal, 1000);
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; scan(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
